import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import {
  selectCurrentPage,
  selectTotalItem,
} from 'affiny-core/redux/selectors/photoRevealsSelectors';
import { all, call, takeLatest } from 'redux-saga/effects';
import { getPhotoReveals } from '../api/repositories/photoPrivacy/photoReveals';
import { ActionsOfType } from '../helpers';
import { checkHasCompletedProfile } from '../helpers/checkSaga';
import { getPaginatedData } from '../helpers/pagination';
import {
  EPhotoRevealsActionType,
  photoRevealsActions,
  TPhotoRevealsActions,
} from './actions';

export function* getPhotoRevealsSaga(
  action: ActionsOfType<TPhotoRevealsActions, EPhotoRevealsActionType.GET>
) {
  if (!(yield* checkHasCompletedProfile())) return;

  yield call(getPaginatedData, {
    pageSelector: selectCurrentPage,
    totalSelector: selectTotalItem,
    reset: action.payload.reset,
    apiCall: getPhotoReveals,
    resetAction: photoRevealsActions.resetPhotoReveals,
    successAction: photoRevealsActions.getPhotoRevealsSuccess,
    pageSize: 10,
  } as any);
}

export function* photoRevealsRootSaga() {
  yield all([
    takeLatest(
      EPhotoRevealsActionType.GET,
      handleAsyncStatus(getPhotoRevealsSaga, EAsyncEventTypes.GET_PHOTO_REVEALS)
    ),
  ]);
}
